namespace TabAurous.Retail {
    export namespace TopProductsService {
        export const baseUrl = 'POSSales/TopProducts';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "POSSales/TopProducts/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>TopProductsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
